export enum BetaBadgeType {
  Default = '',
  Flexible = 'badge-beta-flexible'
}
